import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { HubSpotConfigurationFooter } from './components/HubSpotConfigurationFooter';
import { HubSpotConfigurationForm } from './components/HubSpotConfigurationForm';
import type { HubSpotConfigurationFormValues } from './HubSpotConfigurationFormSchema';
import { HubSpotConfigurationFormSchema } from './HubSpotConfigurationFormSchema';

export const ConfigureHubSpotComponents: FormDrawerProps<ZodSchema<HubSpotConfigurationFormValues>> = {
  zodSchema: HubSpotConfigurationFormSchema,
  ContentComponent: HubSpotConfigurationForm,
  Footer: HubSpotConfigurationFooter,
};
